import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-md",
  "use": "icon-md-usage",
  "viewBox": "0 0 64 64",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 64 64\" id=\"icon-md\">\r\n<path d=\"M31.7,28.1C47.9,28.1,61,24,61,19v-7.3c0-5.1-13.1-9.1-29.2-9.1c-16.1,0-29.2,4.1-29.2,9.1V19C2.5,24,15.6,28.1,31.7,28.1z\" />\r\n<path d=\"M31.7,44.5c16.1,0,29.2-4.1,29.2-9.1v-11c0,5.1-13.1,9.1-29.2,9.1c-16.1,0-29.2-4.1-29.2-9.1v11\r\n\tC2.5,40.4,15.6,44.5,31.7,44.5z\" />\r\n<path d=\"M31.7,50c-16.1,0-29.2-4.1-29.2-9.1v11c0,5,13.1,9.1,29.2,9.1C47.9,61,61,56.9,61,51.8v-11C61,45.9,47.9,50,31.7,50z\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/md.svg
// module id = Z0w5
// module chunks = 217